module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"part":"Del","partsExplanation":"Alle videoene er inndelt i 3-minutters brain dates, slik at du kan se dem i deler.","back":"Tilbake"},"en":{"part":"Part","partsExplanation":"All videos are split into 3 minute brain dates, so that you can enjoy them in parts.","back":"Back"}}')
  delete Component.options._Ctor
}
